import { getFormInitialValues } from 'utils/methods/helpers';
import { ASSET_TYPE_FIELDS } from 'utils/formFields/assetType';
import {
  validateRequired,
  validateString,
  validationObject,
} from 'utils/validations';

export const initialState = {
  assetTypeId: '',
  category: '',
  name: '',
  qualificationRequired: false,
  handoverRequired: false,
  archived: false,
};

export const initialValues = data => {
  return getFormInitialValues(data);
};

export const generalSection = ({
  allowableCategories,
  enableEmbeddedAssetCategory,
}) => [
  ASSET_TYPE_FIELDS.id,
  ASSET_TYPE_FIELDS.category({
    allowableCategories,
    size: 'half',
    valueType: 'object',
    disabled: !enableEmbeddedAssetCategory,
  }),
  ASSET_TYPE_FIELDS.name(),

  ASSET_TYPE_FIELDS.qualificationRequired,
  ASSET_TYPE_FIELDS.handoverRequired,
];

export const detailedSection = () => {
  return [ASSET_TYPE_FIELDS.description];
};

export const validationSchema = validationObject({
  category: validateRequired(),
  name: validateString(30, true),
  assetTypeId: validateString(30, false),
});
